import { Redirect } from "expo-router";

export default function OnboardingFallbackScreen() {
  return <Redirect href="/(auth)/login" />;
}
